export default {
  //TODO: REMOVE AND USE NEW TRANSLATIONS
  COULDNT_SEE_ANYONE: `No pude ver a nadie.`,
  COULDNT_HEAR_ANYONE: `No pude oír a nadie.`,
  IMAGE_QUALITY_POOR: `La calidad de la imagen fue muy mala.`,
  SOUND_QUALITY_POOR: `La calidad del sonido fue muy malo.`,
  TROUBLE_JOINING_CALL: `Las personas tuvieron dificultades para unirse a la llamada.`,

  HEADER: `Gracias por tu paciencia.`,
  TELL_ISSUE_HAVING: `Cuéntanos sobre el problema que tienes.`,
  TELL_US_MORE: `Cuéntanos más.`,
  REPORT_INFO_OTHER: `Información adicional del informe.`,
  MORE_INFO_CONSENT: `No uses este campo para compartir información de salud personal ni para dejar mensajes para tu proveedor. Si
  tienes preguntas sobre tu atención. Contacta con el consultorio de tu proveedor.`,
  WILL_IMPROVE: `Utilizaremos estos comentarios para mejorar constantemente nuestros productos para ti.`,

  SEND_FEEDBACK_BUTTON: `Enviar comentarios`,
  CLOSE_BUTTON: `Cerrar`,

  // NEW TRANSLATIONS
  REPORT_ISSUE_HEADING: `Reportar problema`,

  REPORT_ISSUE_TYPE_LABEL: `¿Qué problemas tienes?`,
  REPORT_ISSUE_TYPE_PLACEHOLDER: `- Escribe o Selecciona -`,
  REPORT_ISSUE_TYPE_1: `No pude ver a nadie`,
  REPORT_ISSUE_TYPE_2: `No pude oír a nadie`,
  REPORT_ISSUE_TYPE_3: `La calidad de la imagen fue mala`,
  REPORT_ISSUE_TYPE_4: `La calidad del sonido fue mala`,
  REPORT_ISSUE_TYPE_5: `La gente tuvo problemas para unirse a la llamada`,
  REPORT_ISSUE_TYPE_6: 'Otro',
  REPORT_ISSUE_TYPE_ERROR: `Escribe o selecciona un asunto para continuar.`,

  REPORT_ISSUE_EXPLANATION_LABEL_1: `Por favor, explica`,
  REPORT_ISSUE_EXPLANATION_LABEL_2: `(opcional)`,
  REPORT_ISSUE_EXPLANATION_PLACEHOLDER: `Cuéntanos qué salió mal y dónde.`,

  REPORT_ISSUE_NOTIFICATION: `Estos campos no están destinados a tu proveedor. Los comentarios enviados aquí se utilizarán para mejorar esta aplicación web para ti.`,
  REPORT_ISSUE_SEND_FEEDBACK_BUTTON: `Danos tu opinión`,
  REPORT_ISSUE_SEND_CLOSE_BUTTON: `Cerrar`,
  REPORT_ISSUE_FEEDBACK_SENT: `Comentario enviado`,
  REPORT_ISSUE_FEEDBACK_THANK_YOU: `Gracias por informarnos de su problema.`,

  // footer
  FOOTER_A11Y_STATEMENT: `Declaración de Accesibilidad`,
};
